import React, { Component } from 'react';
//import PropTypes from 'prop-types';

class CategoryView extends Component {

  render() {

    const bg_color = (this.props.draft_item.get("category_id") === this.props.id ? "yellow" : "")

    return (
        <div onClick={this.props.handleClick} style={{backgroundColor:bg_color}}>
          <h3 className="category-text light">{this.props.name}</h3>
        </div>
    )
  }
}

export default CategoryView;



// WEBPACK FOOTER //
// ./src/snapit_app/components/CategoryView.js